<script setup lang="ts">
import { ref, onErrorCaptured, watch } from 'vue'
import { sendError } from '@/utils/sendError.ts'
import { useLocalizationStore } from '@/stores/localization.ts'
import Button from '@/components/Button.vue'
import $typo from '@/styles/typografy.module.css'

const props = defineProps<{ routeKey: string }>()

const { t } = useLocalizationStore()
const error = ref<Error | null>(null)

watch(() => props.routeKey, () => {
  error.value = null
})

onErrorCaptured((err: Error) => {
  error.value = err
  sendError(err, { source: 'ErrorBoundary' })
  return false
})

function retry() {
  error.value = null
}

function reload() {
  window.location.assign('/')
}
</script>

<template>
  <slot v-if="!error" />
  <div v-else class="flex flex-col items-center justify-center h-full gap-4 p-6 text-center">
    <p :class="$typo.openSansBold24" class="text-primary">{{ t('errorBoundaryTitle') }}</p>
    <p :class="$typo.openSans14" class="text-secondary">{{ t('errorBoundaryDescription') }}</p>
    <div class="flex gap-3">
      <Button @click="retry">{{ t('errorBoundaryRetry') }}</Button>
      <Button @click="reload">{{ t('errorBoundaryReload') }}</Button>
    </div>
  </div>
</template>
